import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';

const SLIDE_INITIAL = { opacity: 0, x: 50 };
const SLIDE_ANIMATE = { opacity: 1, x: 0 };
const SLIDE_EXIT = { opacity: 0, x: -50 };
const SLIDE_TRANSITION = { duration: 0.3 };

const LOGO_STYLE = {
  filter: 'brightness(0) invert(1) contrast(2)',
  mixBlendMode: 'screen'
};

const TestimonialCard = ({ testimonial, currentIndex }) => (
  <AnimatePresence mode="wait">
    <motion.div
      key={currentIndex}
      initial={SLIDE_INITIAL}
      animate={SLIDE_ANIMATE}
      exit={SLIDE_EXIT}
      transition={SLIDE_TRANSITION}
      className="relative z-10"
    >
      {testimonial.companyLogo && (
        <div className="flex flex-col items-center mb-8">
          <div className="px-8 py-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 mb-4">
            <img
              src={testimonial.companyLogo}
              alt="Company Logo"
              className="h-12 w-auto object-contain"
              style={LOGO_STYLE}
            />
          </div>
          <div className="flex gap-1">
            {Array.from({ length: testimonial.rating || 5 }).map((_, i) => (
              <Star key={`star-${currentIndex}-${i}`} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
        </div>
      )}

      <p className="text-xl md:text-2xl text-gray-300 mb-8 italic leading-relaxed">
        &ldquo;{testimonial.text}&rdquo;
      </p>
      <div className="flex items-center space-x-4">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-500 to-blue-500 flex items-center justify-center text-white font-bold text-xl">
          {testimonial.name.charAt(0)}
        </div>
        <div>
          <h4 className="text-white font-semibold text-lg">{testimonial.name}</h4>
          <p className="text-gray-400">{testimonial.company}</p>
        </div>
      </div>
    </motion.div>
  </AnimatePresence>
);

export default TestimonialCard;
